export const RESET_PASSWORD = 'routes/Account/ResetPassword/resetPassword';

export const resetPassword = (password, intl, history, reset) => ({
    type: RESET_PASSWORD,
    payload: { intl, history, password, reset },
});
